// extracted by mini-css-extract-plugin
export default {"InputWrapper":"EnterMfaCodeFieldset_InputWrapper__E0pUV","Input":"EnterMfaCodeFieldset_Input__cx6Ur"};